import { getUserCountsByJourneysIds, journeyUserCountsByNode } from "Services/Journeys.service";
import { getLogger } from "Services/LoggingService";
import { NodeMetricsData } from "Types/Journey";

const logger = getLogger("Journeys Editor");

export async function fetchJourneyAnalytics(journeyId: string): Promise<Record<string, NodeMetricsData>> {
    try {
        const { nodes: nodeMetrics } = await journeyUserCountsByNode(journeyId);

        return nodeMetrics.reduce((analyticsData: Record<string, NodeMetricsData>, nodeMetric: NodeMetricsData) => {
            analyticsData[nodeMetric.nodeUuid] = nodeMetric;
            return analyticsData;
        }, {});
    } catch (err) {
        logger.error(`Could not fetch journeys metric data for journey ${journeyId}`, { err });
        return {};
    }
}

export async function fetchJourneyUserStats(journeyId: string) {
    try {
        const { journeyPageCounts } = await getUserCountsByJourneysIds({ journeysIds: [journeyId] });
        return journeyPageCounts;
    } catch (err) {
        logger.error(`Could not fetch journeys metric data for journey ${journeyId}`, { err });
        return null;
    }
}
